import Web3 from 'web3'
import BigNumber from 'bignumber.js'
import minABI from '../configs/minABI'
import { instanceWithAuth } from '.'

const config = {
  // mainnet
  url: 'https://mainnet.infura.io/v3/cfd9cfe0a9be4639a39de9ec5f2e50a8',
  plp_addr: '0xf8cfee0e8b66ca6ca8da75c955e5e05bd41090c8',
  ssp_addr: '0xbf055278792828bdbace2e38d3e4a93328366c26',
  usdt_addr: '0xdac17f958d2ee523a2206206994597c13d831ec7',
  chainId: 1
}
const _config = {
  // testnet
  url: 'https://ropsten.infura.io/v3/cfd9cfe0a9be4639a39de9ec5f2e50a8',
  plp_addr: '0xf35e2531ee0111228cf32ece837d7cabed235af5',
  ssp_addr: '0x854d0bdbfa2e155119b26617a9b3b37d087f9d7a',
  usdt_addr: '0x512a34a032116ecde07bfe47e731b2d16b77a5fb',
  chainId: 3
}
const web3 = new Web3(new Web3.providers.HttpProvider(config.url))

const getTokenBalance = (tokenAddress, walletAddress) => {
  return new Promise((resolve, reject) => {
    let contract = new web3.eth.Contract(minABI, tokenAddress)

    const decimals = contract.methods.decimals().call()

    const balance = contract.methods
      .balanceOf(walletAddress)
      .call()
      .then((res) => {
        decimals.then((deci) => {
          // resolve(res / 10 ** deci)
          resolve(BigNumber(res).div(BigNumber('10').pow(deci)))
        })
      })
  })
}

const getEthBalance = (walletAddress) => {
  return new Promise((resolve, reject) => {
    web3.eth.getBalance(walletAddress, function(err, result) {
      if (err) reject(err)
      resolve(web3.utils.fromWei(result))
    })
  })
}

const getRawTx = (walletAddress, params) => {
  // console.log('getRawTx');

  return new Promise((resolve, reject) => {
    let aa = web3.utils.toHex(4)

    web3.eth.getTransactionCount(walletAddress, 'pending', function(
      err,
      nonce
    ) {
      // console.log('rawTx start', err)
      if (err) reject(err)

      const _gasPrice = BigNumber(params.fee)
        .div(10)
        .toString()
      if (params.symbol == 'eth') {
        // console.log('eth');

        const tx = {
          nonce: web3.utils.toHex(nonce),
          to: params.toAddress,
          value: web3.utils.toHex(
            web3.utils.toWei(params.amount.toString(), 'ether')
          ),
          gasPrice: web3.utils.toHex(web3.utils.toWei(_gasPrice, 'gwei')), // 가스 가격
          gasLimit: web3.utils.toHex('60000'), // 가스 최대 사용량
          chainId: config.chainId // EIP 155 chainId - mainnet: 1, ropsten(teset): config.chainId
        }
        // console.log('eth2');
        const out = {
          ethVal: web3.utils.fromWei('60000', 'gwei'),
          rawTx: tx
        }
        // console.log('rawTx', out)
        resolve(out)
      } else {
        const to = config[`${params.symbol}_addr`]
        // if (params.symbol == 'plp') to = config.plp_addr
        // else if (params.symbol == 'usdt') to = config.usdt_addr
        // else if (params.symbol == 'ssp') to = config.ssp_addr
        const _gasLimit = params.symbol == 'usdt' ? '70000' : '60000'
        let contract = new web3.eth.Contract(minABI, to)
        contract.methods
          .decimals()
          .call()
          .then((deci) => {
            const fmt = {
              prefix: '',
              decimalSeparator: '.',
              groupSeparator: ''
            }
            return BigNumber(params.amount)
              .times(BigNumber('10').pow(deci))
              .toFormat(fmt)
          })
          .then((res) => {
            try {
              // console.log('amount: ', res.toString())
              const tx = {
                nonce: web3.utils.toHex(nonce),
                to: to,
                data: contract.methods
                  .transfer(params.toAddress, res.toString())
                  .encodeABI(),
                value: '0x0',
                gasPrice: web3.utils.toHex(web3.utils.toWei(_gasPrice, 'gwei')), // 가스 가격
                gasLimit: web3.utils.toHex(_gasLimit), // 가스 최대 사용량
                chainId: config.chainId
              }
              const out = {
                ethVal: web3.utils.fromWei(_gasLimit, 'gwei'),
                rawTx: tx
              }
              resolve(out)
            } catch (e) {
              reject(e)
            }
          })
      }
    })
  })
}

const getTokenPrice = () => {
  return instanceWithAuth.post('/api/marketcap')
}

export {
  minABI,
  getTokenBalance,
  getEthBalance,
  getTokenPrice,
  getRawTx,
  config
}
